<style lang="scss">
@import '../../assets/scss/_variables';

.info-box {
    margin: $grid-size 0;
    padding: 0.1px 0;
    position: relative;
    background: $color-background-1;
    color: $color-white;

    transition: opacity $transition-fade;

    &.fade-enter,
    &.fade-leave-to {
        opacity: 0;
    }
}

    .info-box-icon {
        display: flex;
        position: absolute;
            top: 21px;
            left: $grid-size;

        font-size: 24px;
        color: $color-accent-1;
    }

    .info-box-message {
        margin: 20px 0 20px $grid-size;
        padding-left: 48px;
        padding-right: 20px;

        text-align: left;
        color: $color-white;
    }

@include media-smaller('md') {
    .info-box-icon {
        left: $mobile-pad;
    }

    .info-box-message {
        padding-left: 28px;
    }
}
</style>

<template>
    <div class="info-box">
        <div class="info-box-icon">
            <fa :icon="icon"></fa>
        </div>

        <div class="info-box-message">
            <slot name="message"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['type'],
    computed: {
        icon () {
            switch (this.type) {
            case 'error': return ['fal', 'engine-warning'];
            }
        }
    }
};
</script>
